import omit from 'lodash/omit'
import { useIntl } from 'react-intl'
import { parseErrorMessage } from '../../../../../components'
import { APIErrorType } from '../../../../../components/errors/types/errorTypes'
import { useLocalizedOptionsValue } from '../../../../../hooks'
import { MaybeUserInfo } from '../../../../../types'
import {
  MutationSaveCommunicationsDataArgs,
  MutationSaveUserInfoArgs,
  UserInput
} from '../../../../../utils/classes/graphql'
import { BaseDetailsAddress, BaseDetailsUser } from '../types'
import { createBaseDetailsUser, isAddressTemporaryType } from '../utils'
import { getValidationSchema } from '../validation/validation-schema'

const handleValues = (values: BaseDetailsUser) => {
  const omittedAddressColumns: (keyof BaseDetailsAddress)[] = [
    'addressLocation'
  ]

  const inputAddresses = values.yhteystiedot?.osoitteet?.map(
    (address: BaseDetailsAddress) => {
      const omittedAddressColumnsForType = isAddressTemporaryType(
        address.tyyppi
      )
        ? [...omittedAddressColumns]
        : [...omittedAddressColumns, 'voimaantulopvm', 'paattymispvm']
      const inputAddress = omit(address, omittedAddressColumnsForType)
      return inputAddress
    }
  )

  const userInput = {
    ...values,
    yhteystiedot: {
      ...values.yhteystiedot,
      osoitteet: inputAddresses
    }
  }

  return userInput as UserInput
}

type UserInputValues = MutationSaveUserInfoArgs &
  MutationSaveCommunicationsDataArgs

const createVariables = (values: BaseDetailsUser): UserInputValues => {
  // All values must be declared in api's input (you could, but you don't have to pass all the values to api, like is done in here)
  const variables: UserInputValues = {
    userInfo: {
      ...omit(handleValues(values), ['luvat', 'jasennumero'])
    },
    communicationsData: values.luvat || []
  }
  return variables
}

export const useBaseDetailsFormData = (user: MaybeUserInfo) => {
  const initialValues = createBaseDetailsUser(user)

  const postalCodeOptions = useLocalizedOptionsValue('postalCodeOptions')

  const { formatMessage } = useIntl()

  const getErrorMessage = (error: APIErrorType) => {
    const errorMessageKey = parseErrorMessage(error)
    if (errorMessageKey !== 'common.commonErrors.unknown') {
      return formatMessage({ id: errorMessageKey })
    }
    return ''
  }

  return {
    createVariables,
    getErrorMessage,
    initialValues,
    validationSchema: getValidationSchema(postalCodeOptions)
  }
}
